import { createFileRoute } from '@tanstack/react-router';

import { NewCompanyPage } from '@/features/org/new-company-page';

export const Route = createFileRoute('/_app/org/new')({ component: NewCompanyPage });
